import util from './util';

export default (props) => {
  const firstPagePath = props.location.pathname;
  const noshareReg = /\/my\//g; // 不可分享页面，路径前面加个 '/my/' 的标识 
  const productDetailReg = /^\/product\/1\//g;
  const disableShare = () => {
    window.sayhi.pub('onAppCall', {
      name: 'isShowShare',
      params: {}
    });
  };
  const enableShare = () => {
    window.sayhi.pub('onAppCall', {
      name: 'isShowShare',
      params: {
        show: '1'
      }
    });
  };
  if (noshareReg.test(firstPagePath)) {
    // 不可分享
    disableShare();
  } else {
    enableShare();
  }
  props.history.listen((route) => {
    const currentPagePath = route.pathname;
    if (productDetailReg.test(currentPagePath) && window.sayhi.isBtgApp) { // 产品详情
      const pathArr = currentPagePath.split('/');
      props.history.goBack();
      // 优化 util.setBtgRedirectUrl
      // redirectType, redirectNo, resourceName => '0', pathArr[pathArr.length - 1], ''
      const obj = {
        redirectType: '0', 
        redirectNo: pathArr[pathArr.length - 1], 
        resourceName: '',
        resourceId: pathArr[pathArr.length - 1],
        resourceType: '0'
      };
      window.location.href = util.setBtgRedirectUrl(obj);
    }
    if (noshareReg.test(currentPagePath)) {
      // 不可分享
      disableShare();
    } else {
      enableShare();
    }
  });
};
